<template>
    <v-container>
        <v-row>
            <v-col class="title text-center">Welcome {{ name }}!</v-col>
        </v-row>
        <v-row justify="space-around">
            <v-col class="display-2 text-center" cols=12>
                Cars
            </v-col>
            <v-col md=3 cols=12 v-for="car in cars" :key="car._id">
                <v-card shaped elevation=5 :to="{ name: 'specificCar', params: {carId: car._id}}">
                    <v-container>
                        <v-row>
                            <v-col class="text-center display-1">
                                <v-icon>fas fa-car</v-icon> {{ car.name }} <v-icon>fas fa-car</v-icon>
                            </v-col>
                        </v-row>
                        <v-row class="text-center">
                            <v-col class="title">
                                <v-list disabled>
                                    <v-list-item-group>
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ car.year }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ car.make }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ car.model }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item inactive>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ car.mileage }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-container>
                            <v-row justify="center">
                                <v-col cols=6 class="text-center">
                                    <v-btn color="primary" @click.prevent="toEdit(car._id)" large block>
                                        Edit
                                    </v-btn>
                                </v-col>
                                <v-col cols=6 class="text-center">
                                    <v-btn color="error" @click.prevent="" large block>
                                        Delete
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="space-around">
            <v-col cols=12 md=3>
                <v-card elevation=3>
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <v-card-title>
                                    <v-spacer></v-spacer>
                                    Add MPG Entry
                                    <v-spacer></v-spacer>
                                </v-card-title>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-form>
                                <v-col cols=12>
                                    <v-text-field v-model="miles" type="number" step="0.01" min="0" class="mx-auto" label="Miles"></v-text-field>
                                </v-col>
                                <v-col cols=12>
                                    <v-select :items="typesOfGas" v-model="gasType" label="Gas Type"></v-select>
                                </v-col>
                                <v-col cols=12>
                                    <v-text-field v-model="gallons" type="number" step="0.01" min="0" class="mx-auto" label="Gallons"></v-text-field>
                                </v-col>
                                <v-col cols=12>
                                    <v-text-field v-model="price" type="number" step="0.01" min="0" class="mx-auto" label="Price"></v-text-field>
                                </v-col>
                                <v-col cols=12>
                                    <v-select v-model="selectedCar" :items="carNames" item-text="name" item-value="id" label="Select Car"></v-select>
                                </v-col>
                            </v-form>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-btn block dark color="blue" @click="addMpgEntry" :loading="loading">
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- Gas Station selector Dialog -->
        <v-dialog v-model="multipleGasStations">
            <v-card color="blue darken-3">
                <v-container>
                    <v-row>
                        <v-col class="text-center display-1 font-weight-bold font-italic white--text">Please Select a Gas Station</v-col>
                    </v-row>
                    <v-row justify="center" no-gutters>
                        <v-col cols=5>
                            <v-card class="my-5 text-center" v-for="gs in gasStations" :key="gs.place_id" @click="selectGasStation(gs)">
                                <v-card-title>
                                    <v-spacer></v-spacer>
                                    {{ gs.name }}
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-icon>fas fa-map-marked-alt</v-icon><v-card-text>{{ gs.vicinity }}</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <!-- Alert dialog -->
        <v-dialog v-model="alert" max-width="1600">
            <v-alert prominent :type="alertType" class="title font-italic ma-0">
                {{ statusMsg }}
            </v-alert>
        </v-dialog>
    </v-container>
</template>

<script>
import rp from "request-promise-native";

// const EDWARDS = {
//     lat: 34.920059, 
//     long: -117.927780
// };

// const MOBILE = {
//     lat: 34.689704, 
//     long: -118.166049
// }

export default {
    // Prevent the user from accessing the dashboard if they are not logged in.
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.token.length < 1) {
                next("/login");
            } 
            // TODO Come back and figure out the issue of someone signing up, but on the Create Car screen, they click on dashboard.
            // else if (vm.$store.state.cars.length < 1) {
            //     // Set the signedup state to true as they have signed up but have not moved past that
            //     vm.$store.commit("setSignedUp");
            //     next({name: "Create Car"});
            // } 
            else {
                next();
            }
        })
    },
    data() {
        return {
            typesOfGas: ["Regular", "Extra", "Super/Premium"],
            loading: false,
            multipleGasStations: false,
            gasStations: [],
            statusMsg: "",
            alert: false,
            alertType: "warning"
        }
    },
    computed: {
        name() {
            return this.$store.state.name;
        },
        cars: {
            get() {
                return this.$store.state.cars;
            }
        },
        selectedCar: {
            get() {
                return this.$store.state.selectedCar;
            },
            set(val) {
                this.$store.commit("setSelectedCar", val);
            }
        },
        miles: {
            get() {
                if (this.$store.state.mpgEntry.miles === 0) {
                    return "";
                } else {
                    return this.$store.state.mpgEntry.miles;
                }
            },
            set(val) {
                this.$store.commit("setMiles", val);
            }
        },
        gallons: {
            get() {
                if (this.$store.state.mpgEntry.gallons === 0) {
                    return "";
                } else {
                    return this.$store.state.mpgEntry.gallons;
                }
            },
            set(val) {
                this.$store.commit("setGallons", val);
            }
        },
        price: {
            get() {
                if (this.$store.state.mpgEntry.price === 0) {
                    return "";
                } else {
                    return this.$store.state.mpgEntry.price;
                }
            },
            set(val) {
                this.$store.commit("setPrice", val);
            }
        },
        gasType: {
            get() {
                return this.$store.state.mpgEntry.type;
            },
            set(val) {
                this.$store.commit("setType", val);
            }
        },
        location() {
            return this.$store.state.mpgEntry.location;
        },
        carNames() {
            return this.$store.getters.getCarNames;
        },
        loadingDialog: {
            get() {
                return this.$store.state.loadingDialog;
            },
            set() {
                this.$store.commit("showLoadingDialog");
            }
        }
    },
    methods: {
        async addMpgEntry() {
            // Start the loading symbol on the button
            this.loading = true;
            console.log("In the function...");
            
            // Get the Vue instance
            let self = this;
            // Get the location and wait for that
            await self.$store.dispatch("getLocation");
            
            // Testing the new getLocation route
            let options = {
                method: "POST",
                uri: `${process.env.VUE_APP_HOST}/location`,
                auth: {
                    bearer: self.$store.state.token
                },
                body: {
                    location: {
                        latitude: self.$store.state.mpgEntry.location.latitude,
                        longitude: self.$store.state.mpgEntry.location.longitude
                        // TODO Remove when testing is completed
                        // latitude: EDWARDS.lat,
                        // longitude: EDWARDS.long
                        // latitude: MOBILE.lat,
                        // longitude: MOBILE.long
                    }
                },
                json: true
            };
            
            try {
                const res = await rp(options);

                // If there were no gas stations found
                if (res.statusCode === "404") {
                    self.statusMsg = "No gas stations found!";
                    self.alertType = "warning";
                    self.alert = true;
                }
                
                // Check to see if there are more than one result
                if (res.length > 1) {
                    // Copy res to gasStations
                    self.gasStations = res;

                    // Set multipleGasStations to true
                    self.multipleGasStations = true;
                }

                // If there is only 1 gas station found
                if (res.length == 1) {
                    console.log('Only one gas station...');
                    console.log(res);

                    // Get the gas station
                    let gs = res[0];
                    // Setup the options for rp
                    let options = {
                        method: "POST",
                        uri: `${process.env.VUE_APP_HOST}/cars/${self.$store.state.selectedCar}/mpg`,
                        auth: {
                            bearer: self.$store.state.token
                        },
                        body: {
                            miles: self.$store.state.mpgEntry.miles,
                            gallons: self.$store.state.mpgEntry.gallons,
                            price: self.$store.state.mpgEntry.price,
                            gasType: self.$store.state.mpgEntry.type,
                            location: {
                                latitude: self.$store.state.mpgEntry.location.latitude,
                                longitude: self.$store.state.mpgEntry.location.longitude
                            },
                            gasStation: gs
                        },
                        json: true
                    };

                    try {
                        // Get the response
                        const res = await rp(options);
                        // Update the car in the cars array in the store
                        self.$store.commit("replaceCarInCars", res);
                        // Turn button dialog off
                        self.loading = false;
                        self.statusMsg = "Entry saved!";
                        self.alertType = "success";
                        self.alert = true;

                        // Clear the mpgEntry
                        self.$store.commit("clearMpgEntry");
                        self.$store.commit("clearSelectedCar");
                         
                    } catch (e) {
                        self.statusMsg = e;
                        self.alertType = "error";
                        self.alert = true;
                        
                    }   
                }
                
            } catch (error) {
                console.log(error);
                self.statusMsg = error.message;
                self.alertType = "error";
                self.alert = true;
                
            }
        },
        async selectGasStation(gs) {
            // Get the vue instance            
            let self = this;          

            // Setup the options for rp
            let options = {
                method: "POST",
                uri: `${process.env.VUE_APP_HOST}/cars/${self.$store.state.selectedCar}/mpg`,
                auth: {
                    bearer: self.$store.state.token
                },
                body: {
                    miles: self.$store.state.mpgEntry.miles,
                    gallons: self.$store.state.mpgEntry.gallons,
                    price: self.$store.state.mpgEntry.price,
                    gasType: self.$store.state.mpgEntry.type,
                    location: {
                        latitude: self.$store.state.mpgEntry.location.latitude,
                        longitude: self.$store.state.mpgEntry.location.longitude
                    },
                    gasStation: gs
                },
                json: true
            };

            // Perform the request
            try {
                const res = await rp(options);
                console.log(res);
                self.multipleGasStations = false;
                // Update the car in the cars array in the store
                self.$store.commit("replaceCarInCars", res);
                // Stop the button loading symbol
                self.loading = false;
                self.statusMsg = "Entry saved!"
                self.alertType = "success";
                self.alert = true;
                // Clear the form
                self.$store.commit("clearMpgEntry");
                self.$store.commit("clearSelectedCar");
                
            } catch (e) {
                console.log(e);
                self.statusMsg = e;
                self.alertType = "error";
                self.alert = true;
            }
            
        },
        toEdit(id) {
            this.$router.push({ name: "Edit Car", params: { carId: id}});

        }
    },
    mounted: async function() {
        // Check to see if the cars have been loaded.
        if (this.$store.state.cars.length < 1) {
            // Get the users cars
            try {
                await this.$store.dispatch("loadCars", this.$store.state.token);

                // Check to see if there are any cars
                if (this.$store.state.cars.length < 1 && this.$store.state.token.length > 1) {
                    // TODO Consider changing this as it allows the page to load.
                    // Set the signedup flag
                    this.$store.commit("setSignedUp");
                    this.$router.push("/createCar");
                }
            } catch (e) {
                console.log(e);
            }
        }

        // Proceed with everything else
    },
    watch: {
        alert() {
            if (this.alert == false) {
                // To make the loading icon on the button stop.
                this.loading = false;
            }
        }
    }
}
</script>